import Pattern from 'elements/Pattern';
import {
    ApplyButton,
    MekiHero,
    MekiSectionHeading,
    Paragraphs,
} from 'components/MekiPageSections';

const whySections = [
    {
        title: 'Rugalmas munkaidő',
        subTitle: 'Igazítsd az életedhez a munkaidődet!',
        image: '/assets/images/miert_a_meki_1.jpg',
        paragraphs: [
            'Tudjuk, hogy számodra a suli az első. Tudjuk, hogy a diákmunkára szánható idődet emellett befolyásolja a családod, a barátaid és a kötelezettségeid. A Meki viszont rugalmas munkát ajánl minden diáknak, hogy azt a saját életükhöz tudják igazítani. Szóval, ha rugalmas diákmunka kell, akkor a Meki tökéletes választás.',
            'Csak annyi kötelezettséget kell vállalnod, hogy hetente legalább 16 órát dolgozol 4, 6 vagy 8 órás műszakokban. És ez nem is olyan sok…',
            'Ha például tudsz a suli után hetente kétszer 4-4 órát elvállalni, és a hétvégén belefér még egy 8 órás műszak, akkor már meg is vagy. Ráadásul, ha a két hétköznapi műszakot délután 6 és este 10 között vállalod, akkor nem csak az alapbér, hanem a 18 óra után automatikusan járó műszakpótlék is a markodat üti.',
            'Ez a beosztás persze csak egy példa, a diákok beosztását minden esetben előre egyeztetve az étteremvezetők állítják össze.',
        ],
    },
    {
        title: 'Jó társaság',
        subTitle: 'Dolgozz akár a barátaiddal együtt!',
        image: '/assets/images/miert_a_meki_2.jpg',
        reverse: true,
        apply: true,
        paragraphs: [
            'Minden Mekiben egyedi és szuper társaság vár, akikkel jó eltölteni a munkaidőt. A pörgésben egymást támogatják, igazi csapatjátékosok.',
            'Vannak Fürge Diákok, akik barátokra és baráti társaságokra leltek az évek alatt, és vannak, akik szerelmet találtak. De vannak olyanok, akik már mint baráti társaság jelentkeztek ugyanabba az étterembe, és az esetek többségében sikerül is őket ugyanabba a műszakba beosztani.',
            'Így a Meki diákmunkával nem csak értéket teremtesz és pénzt keresel, hanem a haverokkal is lehetsz.',
            'Ne szalaszd el ezt a lehetőséget, mert ilyen diákmunkát nehezen találsz!',
        ],
    },
    {
        title: 'Megközelíthető munkahely',
        subTitle: 'Válaszd azt az éttermet, ami neked leginkább útba esik!',
        paragraphs: [
            'Szerencsére a Meki esetében te mondhatod meg, hogy hol szeretnél dolgozni. Budapesten rengeteg Meki várja a diákokat, és azt választhatod, ami beleillik az életedbe.',
            'A körúthoz közel esik a suli, és munkából gyorsan haza akarsz érni? Válogass a 4-6 villamos vonalán lévő 9 Meki étterem egyikéből.',
            'Esetleg Budapest egyik plázája lenne a tökéletes választás számodra? Abból is akad bőven: West End, Aréna Mall, Duna Pláza, Lurdy Ház, Campona Mall, Mom Park, Árkád, Pólus Center',
            'Budapesten és környékén összesen 47 Meki étteremből választhatsz diákmunka helyszínt.',
            'Vidéken pedig további 26 étteremben várunk diákmunka lehetőséggel.',
            'A teljesség igénye nélkül az alábbi városokban: Mosonmagyaróvár, Győr, Zalaegerszeg, Szombathely, Keszthely, Veszprém, Bábolna, Tatabánya, Siófok, Kaposvár, Pécs, Szekszárd, Eger, Gyöngyös, Salgótarján, Szolnok, Kecskemét, Szeged, Békéscsaba, Debrecen, Miskolc.',
        ],
    },
    {
        title: 'Fejlődési lehetőség',
        subTitle: 'Nem csak sokat fejlődhetsz, a karrierrendszer diákként is elérhető!',
        image: '/assets/images/miert_a_meki_3.jpg',
        apply: true,
        paragraphs: [
            'A Fürge Diákok szerint a Meki nem csak egy munkahely és nem csak egy jó társaság. A Meki számukra megtanította a csapatmunka és az együttműködés fontosságát, a kitartást, az alázatosság előnyeit. Beletanultak a munka világába, amit a jövőben kamatoztatni tudnak.',
            'Vannak olyan Fürge Diákok is, akik már elől járnak a Meki karrierrendszerében: műszakvezetőként, trénerként vagy étteremvezető helyettesként állják meg helyüket nap mint nap az iskola mellett.',
            'És ez a lehetőség számodra is adott. Próbáld ki magad, és legyen saját pénzed!',
        ],
    },
];

export default function MekiWhyPage() {
    return (
        <main className='w-full bg-white/20'>
            <MekiHero
                title='Ezért jó a Mekis diákmunka…'
                lead='Rengeteg dolog szól a Meki diákmunka lehetősége mellett. Lentebb azokat emeltük ki, amik miatt a Mekiben dolgozó Fürge Diákok ezt a diákmunkát választották. Mekizz velünk te is!'
                image='/assets/images/miert_a_meki.jpg'
                contentId='meki-elonyok'
            />

            <section id='meki-elonyok' className='relative z-10 -mt-6 scroll-mt-20 overflow-hidden bg-stone-50 px-site pb-16 pt-28 sm:pb-24 sm:pt-32'>
                <Pattern className='pointer-events-none opacity-10 mix-blend-multiply' />
                <div className='relative z-10 mx-auto flex w-full max-w-boxed flex-col gap-8 sm:gap-10 lg:gap-12'>
                    {whySections.map((item) => <WhySection key={item.title} item={item} />)}
                </div>
            </section>
        </main>
    );
}

function WhySection({ item }) {
    if (!item.image) {
        return (
            <article className='relative overflow-hidden rounded-3xl bg-gradient-to-br from-red-800 via-red-700 to-red-600 p-6 text-white shadow-2xl sm:p-10 lg:p-12'>
                <Pattern className='pointer-events-none opacity-45' />
                <div className='relative z-10'>
                    <MekiSectionHeading light>{item.title}</MekiSectionHeading>
                    <h3 className='mt-3 font-display text-xl font-black text-white sm:text-2xl'>{item.subTitle}</h3>
                    <Paragraphs items={item.paragraphs} className='mt-7 text-white/90' />
                </div>
            </article>
        );
    }

    return (
        <article className='grid grid-cols-1 overflow-hidden rounded-3xl bg-white shadow-2xl shadow-red-900/5 lg:grid-cols-2'>
            <figure className={`min-h-72 overflow-hidden sm:min-h-96 ${item.reverse ? 'lg:order-2' : ''}`}>
                <img src={item.image} alt='' className='size-full object-cover' />
            </figure>
            <div className={`flex flex-col justify-center p-6 sm:p-10 lg:p-12 ${item.reverse ? 'lg:order-1' : ''}`}>
                <MekiSectionHeading>{item.title}</MekiSectionHeading>
                <h3 className='mt-3 font-display text-xl font-black text-lime-600 sm:text-2xl'>{item.subTitle}</h3>
                <Paragraphs items={item.paragraphs} className='mt-7' />
                {item.apply && <ApplyButton className='mt-8 self-start' />}
            </div>
        </article>
    );
}
